import { useGlobalLoading } from '../UI/LoadingComponent/store';
import LoadingComponent from '../UI/LoadingComponent';
import { Box } from '@mui/material';

const GlobalLoading = () => {
  const isGlobalLoading = useGlobalLoading((state) => state.isGlobalLoading);

  return isGlobalLoading ? (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100vw"
      height="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgcolor="rgba(255, 255, 255, 0.6)"
      zIndex={1300}
    >
      <LoadingComponent />
    </Box>
  ) : null;
};

export default GlobalLoading;
